/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { DropdownItem } from './dropdown-helpers';

export const LozengeWrapper = styled.span({
  paddingLeft: '8px',
});

export const NonInteractiveDropdownItem = styled(DropdownItem)({
  pointerEvents: 'none',
});

export const ProfileWrapper = styled.div({
  display: 'flex',
  flexDirection: 'row',
});

export const AvatarWrapper = styled.div({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginRight: '8px',
});
